import {LoanApplicationDocumentType} from './loan-application-document-type.model';
import {AddressProofType} from './address-proof-type.model';

export class Proof {
    public _id: string;
    public proofType: LoanApplicationDocumentType | AddressProofType;
    public proofNumber: string;
    public fileIds: string[];
    public comments: string;

    constructor(proofType: LoanApplicationDocumentType | AddressProofType,
                proofNumber?: string, fileIds?: string[]) {
        this.proofType = proofType;
        this.proofNumber = proofNumber;
        this.fileIds = fileIds;
    }
}
